var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('iframe',{staticStyle:{"pointer-events":"none","border":"none"},attrs:{"scrolling":"no","unselectable":"on","src":_vm.getnewiframeurl,"width":_vm.w,"height":_vm.h}})])}
var staticRenderFns = []

export { render, staticRenderFns }